import { render } from "./zloading.vue?vue&type=template&id=b5b9585a&scoped=true"
import script from "./zloading.vue?vue&type=script&lang=js"
export * from "./zloading.vue?vue&type=script&lang=js"

import "./zloading.vue?vue&type=style&index=0&id=b5b9585a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5b9585a"

export default script